"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Image = _interopRequireDefault(require("../v1/components/Image/Image"));
const PoweredByGoogle = ({
  className,
  cloudinaryImageId,
  imageWidth,
  imageHeight
}) => {
  const classes = (0, _classnames.default)('PoweredByGoogle', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement(_Image.default, {
    className: "PoweredByGoogleImage",
    cloudinaryImageId: cloudinaryImageId,
    width: imageWidth,
    height: imageHeight
  }));
};
PoweredByGoogle.defaultProps = {
  cloudinaryImageId: 'front-end/powered-by-google',
  imageWidth: 144,
  imageHeight: 18
};
var _default = exports.default = PoweredByGoogle;